import { createContext } from "react";

import {
  ListUserInspectionsResponse,
  ListUserTemplatesResponse,
  Pagination,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

type UserInspectionListContextType = {
  userInspectionsList: UserInspectionsList;
  setUserInspectionsList: React.Dispatch<
    React.SetStateAction<UserInspectionsList>
  >;
};

export type UserInspectionsList = {
  userInspectionsListResponse: ListUserInspectionsResponse;
  pagination: Pagination;
  isLoading: boolean;
};

export const UserInspectionListContext =
  createContext<UserInspectionListContextType>(
    {} as UserInspectionListContextType,
  );

type UserTemplateListContextType = {
  userTemplatesList: UserTemplatesList;
  setUserTemplatesList: React.Dispatch<React.SetStateAction<UserTemplatesList>>;
};

export type UserTemplatesList = {
  userTemplatesListResponse: ListUserTemplatesResponse;
  pagination: Pagination;
  isLoading: boolean;
};

export const UserTemplateListContext =
  createContext<UserTemplateListContextType>({} as UserTemplateListContextType);
